import { render } from "./attStart.vue?vue&type=template&id=591aab36&scoped=true"
import script from "./attStart.vue?vue&type=script&lang=js"
export * from "./attStart.vue?vue&type=script&lang=js"

import "./attStart.vue?vue&type=style&index=0&id=591aab36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591aab36"]])

export default __exports__